const getUserData = (rootState) => rootState.ws.integration.settings.userData;

export default getUserData;
